var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8384 8.66772L19.0748 19.1404H7.67798L13.8384 8.66772Z",
    fill: "url(#paint0_linear_3408_297)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.97957 0.120117C0.930508 0.120117 0.0800781 0.970547 0.0800781 2.0196V17.2155C0.0800781 18.2646 0.930508 19.115 1.97957 19.115H7.67803L13.8385 8.64214L19.075 19.115H24.7734C25.8225 19.115 26.6729 18.2646 26.6729 17.2155V4.86883C26.6729 3.81978 25.8225 2.96935 24.7734 2.96935H19.3483C18.0021 2.96935 16.7564 3.68181 16.0738 4.84217L13.8385 8.64214L10.6275 2.22014C9.98401 0.933107 8.66856 0.120117 7.22962 0.120117H1.97957Z",
    fill: "url(#paint1_linear_3408_297)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3408_297",
    x1: 13.3764,
    y1: 24.3385,
    x2: 13.3764,
    y2: -6.0533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#01FCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#2297F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161D23",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3408_297",
    x1: 4.8288,
    y1: 22.4391,
    x2: 11.477,
    y2: -13.6512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01FCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#2297F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161D23",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.da15429541fa0d963a9bb64ec344c734.svg";
export { ForwardRef as ReactComponent };